<template>
  <v-dialog v-model="show" width="auto" scrollable persistent>
    <v-card height="auto" width="80vw">
      <v-toolbar color="primary" dark>
        <span class="text-h5 lighten-2"> Carga de archivo Productos</span>
      </v-toolbar>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" xl="4" lg="4" md="4">
              <v-row>
                <v-col>
                  <v-expansion-panels>
                    <v-expansion-panel>
                      <v-expansion-panel-header
                        disable-icon-rotate
                        expand-icon="mdi-information-slab-circle"
                      >
                        Información de formato archivo
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row>
                          <v-col> Nombre de columnas en archivo </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <ul>
                              <li>
                                <span class="primary--text">name</span>
                                (ejemplo: Pyrenochaeta lycopersici)
                              </li>
                              <li>
                                <span class="primary--text">productName</span>
                                (ejemplo: LALNIX)
                              </li>
                              <li>
                                <span class="primary--text">productType</span>
                                (ejemplo: SOLID, LIQUID)
                              </li>
                              <li>
                                <span class="primary--text">dosesLow</span>
                                (ejemplo: 19.39)
                              </li>
                              <li>
                                <span class="primary--text">dosesMedium</span>
                                (ejemplo: 19.39)
                              </li>
                              <li>
                                <span class="primary--text">dosesHight</span>
                                (ejemplo: 19.39)
                              </li>
                              <li>
                                <span class="primary--text">crop</span>
                                (ejemplo: olive)
                              </li>
                              <li>
                                <span class="primary--text"
                                  >phenologicalStage</span
                                >
                                (ejemplo: Transplanting)
                              </li>
                              <li>
                                <span class="primary--text">symbiosis</span>
                                (ejemplo: benefic o pathogen)
                              </li>
                              <li>
                                <span class="primary--text">status</span>
                                (ejemplo: TECHNICAL_SHEET o FEEDBACK)
                              </li>
                            </ul>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-autocomplete
                    :search-input.sync="searchLab"
                    v-model="labFound"
                    :items="laboratories"
                    label="Buscar CMDA..."
                    hide-no-data
                    outlined
                    dense
                    item-text="name"
                    clearable
                    return-object
                    prepend-inner-icon="mdi-magnify"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-autocomplete
                    :search-input.sync="searchPackage"
                    v-model="packageFound"
                    :items="packagesList"
                    label="Buscar paquete..."
                    hide-no-data
                    outlined
                    dense
                    item-text="name"
                    clearable
                    return-object
                    prepend-inner-icon="mdi-magnify"
                    :disabled="!labFound"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-file-input
                    outlined
                    label="Adjuntar archivo..."
                    prepend-inner-icon="mdi-file-excel"
                    truncate-length="50"
                    show-size
                    :prepend-icon="null"
                    accept=".csv"
                    @change="processFile"
                    v-model="file"
                    :loading="loadingData"
                    dense
                    :disabled="!labFound || !packageFound"
                  >
                  </v-file-input>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" xl="8" lg="8" md="8">
              <v-row>
                <v-col>
                  <v-simple-table
                    class="overflow-y-auto"
                    height="400px"
                    fixed-header
                    v-if="rawData.length != 0"
                  >
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">Fila</th>
                          <th class="text-left">Marcador</th>
                          <th class="text-left">Producto</th>
                          <th class="text-left">Cultivo</th>
                          <th class="text-left">Etapa fenologica</th>
                          <th class="text-left">Tipo de producto</th>
                          <th class="text-left">Rango</th>
                          <th class="text-left">Estatus</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in rawData" :key="index">
                          <td>{{ item.row }}</td>
                          <td>{{ item.name }}</td>
                          <td>{{ item.productName }}</td>
                          <td>{{ item.crop }}</td>
                          <td>{{ item.phenologicalStage }}</td>
                          <td>{{ item.productType }}</td>
                          <td>
                            bajo: {{ item.dosesLow }}
                            <v-spacer></v-spacer>
                            medio: {{ item.dosesMedium }}
                            <v-spacer></v-spacer>
                            alto: {{ item.dosesHight }}
                          </td>
                          <td>
                            <span v-if="item.errors.length != 0">
                              <div
                                v-for="(error, indexError) in item.errors"
                                :key="indexError"
                              >
                                <v-icon color="red" x-small
                                  >mdi-close-circle</v-icon
                                >
                                <span> {{ error }}</span>
                                <v-spacer></v-spacer>
                              </div>
                            </span>
                            <span v-else>
                              <v-icon color="primary">mdi-check-circle</v-icon>
                              Listo
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <v-simple-table
                    class="overflow-y-auto"
                    height="400px"
                    fixed-header
                    v-else
                  >
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">Fila</th>
                          <th class="text-left">Marcador</th>
                          <th class="text-left">Producto</th>
                          <th class="text-left">Cultivo</th>
                          <th class="text-left">Etapa fenologica</th>
                          <th class="text-left">Estatus</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td colspan="6">
                            <v-container>
                              <v-row class="text-center">
                                <v-col>
                                  <span class="font-italic">
                                    No hay datos
                                  </span>
                                </v-col>
                              </v-row>
                            </v-container>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
                <v-col cols="12">
                  <v-btn
                    color="primary"
                    :disabled="getSuccesCount() == 0"
                    @click="createProducts"
                    :loading="loadingMultiple"
                    >Agregar ({{ getSuccesCount() }})</v-btn
                  >
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col>
              <v-btn
                dark
                color="gray"
                block
                @click="show = false"
                :disabled="loadingData"
              >
                Cerrar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//Vuex
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";

export default {
  data: () => ({
    file: null,
    loadingData: false,
    searchLab: null,
    labFound: null,
    laboratories: [],
    searchPackage: null,
    packageFound: null,
    packagesList: [],
    rawData: [],
    loadingMultiple: false,
  }),
  props: {
    value: Boolean,
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    ...mapActions("laboratory", ["getMolecuclarLaboratories", "getPackages"]),
    ...mapActions("prescription", ["addPreProcessFile", "createMultipleLevel"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    async processFile() {
      try {
        if (this.file) {
          this.loadingData = true;
          var formData = new FormData();
          formData.append("file", this.file);
          formData.append("package", this.packageFound._id);
          let response = await this.addPreProcessFile(formData);
          this.rawData = response.rawData;
        } else {
          this.rawData = [];
        }
      } catch (error) {
        this.rawData = [];
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: `Algo salió mal. Error: ${error.message}`,
          timeout: 5000,
        });
      }
      this.loadingData = false;
    },
    getSuccesCount() {
      return this.rawData.filter((element) => element.errors.length == 0)
        .length;
    },
    async createProducts() {
      try {
        this.loadingMultiple = true;
        let payload = {
          products: [],
          packageId: this.packageFound._id,
        };
        payload.products = this.rawData.filter(
          (element) => element.errors.length == 0
        );
        console.log(payload);
        await this.createMultipleLevel(payload);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "success",
          text: `Niveles agregados con exito`,
          timeout: 5000,
        });
        this.$emit("refreshTable");
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: `Algo salió mal. Error: ${error.message}`,
          timeout: 5000,
        });
      }
      this.loadingMultiple = false;
    },
  },
  watch: {
    async searchLab(value) {
      try {
        if (value) {
          let payload = {
            search: value,
          };
          let response = await this.getMolecuclarLaboratories(payload);
          if (response.error) throw response;
          this.laboratories = response.laboratories;
        } else {
          this.laboratories = [];
          this.labFound = null;
        }
      } catch (error) {
        console.log(error);
      }
    },
    labFound(value) {
      if (!value) {
        this.laboratories = [];
        this.labFound = null;
        this.searchPackage = null;
        this.packageFound = null;
        this.packagesList = [];
        this.file = null;
      }
    },
    packageFound(value) {
      if (!value) {
        this.file = null;
      }
    },
    async searchPackage(value) {
      try {
        const req = await this.getPackages({ laboratory: this.labFound._id });

        if (req.error) throw req;

        this.packagesList = req.packages;
        console.log(req);
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
